import { render } from "./MultiInput.vue?vue&type=template&id=1a1680af&scoped=true"
import script from "./MultiInput.vue?vue&type=script&lang=js"
export * from "./MultiInput.vue?vue&type=script&lang=js"

import "./MultiInput.vue?vue&type=style&index=0&id=1a1680af&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1680af"]])

export default __exports__